import { render, staticRenderFns } from "./PicList.vue?vue&type=template&id=7966a818&"
import script from "./PicList.vue?vue&type=script&lang=js&"
export * from "./PicList.vue?vue&type=script&lang=js&"
import style0 from "./PicList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports